
import { isEqual, debounce, isNull } from 'lodash'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import CatalogPagination from './CatalogPagination'
import catalog from './mixins/catalog'
import catalogFiltersParserQueryParams from './CatalogFilters/mixins/catalog-filters-parser-query-params'
import cart from '~/mixins/cart'
import viewportWidth from '~/mixins/viewportWidth'
import {
  getQueryParamsString,
  getUpdateInventoryData,
  mapProductData,
} from '~/components/Catalog/helper'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import TopList from '~/components/Catalog/TopList'
import ProductList from '~/components/Catalog/ProductList'
import localStorage from '~/ZenOne-StoryBook/mixins/localStorage'
import { isArrayWithLength } from '~/ZenOne-StoryBook/helpers/types'
import {
  FILTER_BY_DISTRIBUTOR_ID,
  FILTER_BY_MANUFACTURER_ID,
} from '~/components/Catalog/CatalogFilters/helper'
import AddToFolderDialog from '~/components/Inventory/Dialogs/AddToFolderDialog'
import {
  isObjectNotUndefinedHasProps,
  setAllValuesToNull,
} from '~/ZenOne-StoryBook/helpers/object'
import request from '~/components/Inventory/mixins/request'
import { getBaseUrl } from '~/ZenOne-StoryBook/config/api'
import { RESPONSE_STATUS_OK } from '~/ZenOne-StoryBook/helpers/response'
import { mapLaravelPagination } from '~/ZenOne-StoryBook/helpers/pagination'
import FilterTags from '~/components/Inventory/FolderTemplate/FolderTemplateHeader/FilterTags'
import { getLocalStorage } from '~/ZenOne-StoryBook/helpers/localStorage'
import { removedFromWorkspaceProductAttributes } from '~/components/Inventory/AlertActions/UndoMoveFolderItemsButton/helper'

export default {
  name: 'Catalog',
  components: {
    FilterTags,
    AddToFolderDialog,
    ProductList,
    TopList,
    CatalogPagination,
  },
  mixins: [
    ui,
    cart,
    localStorage,
    catalog,
    catalogFiltersParserQueryParams,
    viewportWidth,
    request,
  ],
  layout: 'left-menu',
  data() {
    return {
      filtersUnwatch: null,
      isFetchingTops: false,
      products: {
        list: [],
        meta: {
          currentPage: this.catalogPageNumberInStore,
          perPage: this.catalogPageSizeInStore,
          from: 1,
          lastPage: 1,
        },
      },
      addToInventory: {
        // todo check
        productDistributorId: null,
        workSpaceId: null,
        workSpaceItemId: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      practiceLocationId: 'user/practiceLocationId',
      tops: 'catalog/tops',
      sort: 'catalog/sort',
      catalogPageNumberInStore: 'catalog/pageNumber',
      catalogPageSizeInStore: 'catalog/pageSize',
      catalogFiltersFromStore: 'catalog/filters',
      isFiltersActive: 'catalog/isFiltersActive',
      showTops: 'catalog/showTops',
      isFetching: 'catalog/isFetching',
      generalProductWorkspace: 'catalog/generalProductWorkspace',
      rootFolderId: 'inventory/rootFolderId',
      sharedFolderIdByRoute: 'inventory/sharedFolderIdByRoute',
      workspaceItemRemovedIds: 'inventory/workspaceItemRemovedIds',
      // todo move it to catalog vuex-module?
    }),
    productsList() {
      return this.products?.list ?? []
    },
    showNoResults() {
      return (
        !this.showTops &&
        !this.isFetching &&
        !isArrayWithLength(this.products?.list)
      )
    },
    showCatalog() {
      const { practiceLocationId } = this
      return parseInt(practiceLocationId) > 0
    },
    isTopsLoaded() {
      return this.tops !== null
    },
    generalProductWorkspaceId() {
      return this.generalProductWorkspace?.workSpaceId ?? null
    },
  },
  watch: {
    generalProductWorkspaceId: {
      handler(workSpaceId = null) {
        if (isNull(workSpaceId)) return false
        const workSpaceItemId =
          this.generalProductWorkspace?.workSpaceItemId ?? null
        const data = {
          workSpaceId,
          workSpaceName: this.generalProductWorkspace?.workSpaceName ?? '',
        }
        const pd = this.findProductByAttr(workSpaceItemId, 'workSpaceItemId')
        const pdId = pd?.id ?? null
        if (!isNull(pdId)) {
          const ids = [...new Set([...this.getCatalogSameBrandIds(pdId), pdId])]
          for (const id of ids) {
            this.updateProductDistributorInList(id, data)
          }
          this.updateProductDistributorInTops(pdId, data)
        }
        this.clearGeneralProductWorkspace()
      },
    },
    catalogPageNumberInStore: {
      handler() {
        this.onFilter()
      },
    },
    catalogPageSizeInStore: {
      handler() {
        this.onFilter()
      },
    },
    isFetching: {
      handler() {
        this.updateLoadingVisibility()
      },
    },
    isFetchingTops: {
      handler() {
        this.updateLoadingVisibility()
      },
    },
    workspaceItemRemovedIds: {
      handler(ids) {
        if (!isArrayWithLength(ids)) return false
        for (const id of ids) {
          this.updateProductDistributorInList(
            id,
            removedFromWorkspaceProductAttributes
          )
        }
        this.clearWorkspaceItemRemovedIds()
      },
    },
  },
  mounted() {
    this.loadTops()
    this.onFilter()
    this.setFiltersWatcher()
  },
  methods: {
    ...mapActions('catalog', [
      'FetchAndSetTops',
      'ClearFilters',
      'SetFilterManufacturer',
      'UpdateFiltersOptions',
      'ClearFilterOptions',
      'clearGeneralProductWorkspace',
      'GetFilterOptions',
    ]),
    ...mapActions('inventory', [
      'SetFolders',
      'SetFolderById',
      'clearWorkspaceItemRemovedIds',
    ]),
    ...mapMutations('catalog', {
      setIsFetching: 'SET_IS_FETCHING',
      setFiltersOnly: 'SET_FILTERS_ONLY',
      setFilterDistributor: 'SET_FILTER_DISTRIBUTOR',
      setTops: 'SET_TOPS',
    }),
    ...mapMutations({
      setNeedFetchItems: 'inventory/SET_NEED_FETCH_ITEMS',
    }),
    clearFiltersBtnClickHandler() {
      this.setIsFetching(true)
      this.ClearFilters({ maintainCurrentFromOrderHistorySetting: false })
      this.setIsFetching(false)
    },
    onUpdateFiltersByTagClick({ filters = {} }) {
      this.setFiltersOnly(filters)
    },
    setFiltersWatcher() {
      this.filtersUnwatch = this.$watch('catalogFiltersFromStore', function () {
        this.onFilter()
      })
    },
    unsetFiltersWatcher() {
      this.filtersUnwatch()
    },
    onAddProductToCart({ productDistributorId = null, qty = 0 }) {
      try {
        if (!productDistributorId) {
          throw new Error('No product distributor id')
        }

        this.addProductToCart({ productDistributorId, qty: !qty ? 1 : qty })
      } catch (e) {
        console.error(`Add to cart error: ${e}`)
      }
    },
    onChangeQtyInCart(data = {}) {
      try {
        const { productDistributorId = null } = data
        if (!productDistributorId) {
          throw new Error('No product distributor id')
        }
        this.changeQtyInCart(data)
      } catch (e) {
        console.error(`Change qty in cart error: ${e}`)
      }
    },
    onShowAddToInventoryDialog({
      productDistributor: {
        productDistributorId,
        workSpaceId,
        workSpaceItemId,
      },
    }) {
      this.addToInventory = {
        productDistributorId,
        workSpaceId,
        workSpaceItemId,
      }
      this.$refs.addToInventoryDialog.show()
    },
    getCatalogSameBrandIds(pdId = null) {
      if (!pdId) return []
      const products = [...this.productsList]
      if (!isArrayWithLength(products)) return []
      const originProduct = products.filter((p) => p.id === pdId)?.[0]
      if (!isObjectNotUndefinedHasProps(originProduct)) return []
      return products
        .filter(
          (p) =>
            parseInt(p.productManufacturerId) ===
            parseInt(originProduct.productManufacturerId)
        )
        .map((p) => p.id)
    },
    async onInventoryUpdate({
      productDistributorId = null,
      workSpaceItem = {},
    }) {
      this.closeAddToInventoryDialog()
      const data = getUpdateInventoryData(workSpaceItem)
      const ids = [
        ...new Set([
          ...this.getCatalogSameBrandIds(productDistributorId),
          productDistributorId,
        ]),
      ]
      ids.forEach((pdId) => this.updateCatalogProductDistributor(pdId, data))
      const workSpaceId = data.workSpaceId
      const folderId = getLocalStorage('activeFolderId')
      if (
        this.sharedFolderIdByRoute === workSpaceId ||
        folderId === workSpaceId
      ) {
        this.setNeedFetchItems()
      }
      await this.SetFolders()
      await this.SetFolderById(workSpaceId)
    },
    onCloseAddToInventoryDialog() {
      this.addToInventory = setAllValuesToNull(this.addToInventory)
    },
    closeAddToInventoryDialog() {
      this.addToInventory = setAllValuesToNull(this.addToInventory)
      this.$refs.addToInventoryDialog.close()
    },
    async onAddToRootFolder({ productDistributorId = null }) {
      const { workSpaceItem = {} } = await this.addProductToFolder(
        productDistributorId,
        this.rootFolderId
      )
      this.updateCatalogProductDistributor(
        productDistributorId,
        getUpdateInventoryData(workSpaceItem)
      )
    },
    updateLoadingVisibility() {
      if (this.isFetchingTops || this.isFetching) {
        this.showFSLoader()
      } else {
        this.hideFSLoader()
      }
    },
    async productCardFilterClickHandler({
      filterName = '',
      value = [],
      vendorName = '',
    }) {
      if (!filterName || !value || !isArrayWithLength(value)) {
        return false
      }
      if (filterName === FILTER_BY_DISTRIBUTOR_ID) {
        this.setFilterDistributor({ value })
      } else if (filterName === FILTER_BY_MANUFACTURER_ID) {
        this.unsetFiltersWatcher()
        await this.SetFilterManufacturer({ value, vendorName })
        this.setFiltersWatcher()
        this.onFilter()
      }
    },
    // breif debounce to prevent double requests when filters change quickly (sometimes code modifies multiple filters, each triggering network request if we do not debounce.)
    onFilter: debounce(function () {
      if (this.isFetching) {
        return
      }

      if (this.showTops) {
        return
      }

      return this.fetchProducts()
    }, 10),
    async fetchTops() {
      if (this.isFetchingTops) {
        return
      }
      this.isFetchingTops = true
      try {
        await this.FetchAndSetTops()
      } catch (e) {
        console.error(`fetchTops: ${e}`)
      } finally {
        this.isFetchingTops = false
      }
    },
    async loadTops() {
      if (this.tops !== null) {
        return
      }
      const res = await this.fetchTops()
      if (!isArrayWithLength(res)) return false
      const [ordered, recentlyPurchased, mostPurchased] = res
      this.setTops({
        ordered: {
          productList: ordered,
        },
        recentlyPurchased: {
          productList: recentlyPurchased,
        },
        mostPurchased: {
          productList: mostPurchased,
        },
      })
    },
    async fetchProducts() {
      // todo move all requests/pagination logic and products[] state to vuex
      try {
        let {
          products: { meta = {} },
        } = this
        meta = {
          ...meta,
          size: this.catalogPageSizeInStore,
          number: this.catalogPageNumberInStore,
        }
        const filterList = { ...this.catalogFiltersFromStore }
        const query = getQueryParamsString(filterList, meta)
        this.setIsFetching(true)
        const url = `${getBaseUrl(process.env.NODE_ENV)}/api/search?${query}`
        const response = await this.$axios.get(url, {})
        if (response?.status !== RESPONSE_STATUS_OK) {
          throw new Error('Response status error')
        }
        const leftSide = document.querySelector('.content .left')
        const wrapper = document.querySelector('.wrapper')
        if (leftSide) {
          leftSide.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        }
        if (wrapper) {
          wrapper.scrollTo({
            top: 152,
            behavior: 'auto',
          })
        }
        const data = response?.data ?? {}
        if (wrapper) {
          wrapper.scrollTo({
            top: 0,
            behavior: 'auto',
          })
        }
        const items = data?.data.reduce((acc, product) => {
          const item = mapProductData(product)
          acc.push(item)
          return acc
        }, [])
        this.products = {
          ...this.products,
          list: [...items],
          meta: { ...mapLaravelPagination(data?.meta) },
        }
        const queryFilters = data?.query?.filters ?? {}
        await Promise.all([
          isObjectNotUndefinedHasProps(queryFilters)
            ? this.updateFiltersBySearchData({ ...queryFilters })
            : null,
        ])
        this.GetFilterOptions()
      } catch (e) {
        const error = `Catalog fetch items: ${
          e?.response?.data?.errors?.[0]?.detail ?? e
        }`
        console.error(error)
        this.showAlert({
          type: this.ERROR,
          content: error,
        })
      } finally {
        this.setIsFetching(false)
      }
    },
    async updateFiltersBySearchData(queryFilters = {}) {
      this.unsetFiltersWatcher()
      const filterNameList = [
        'distributorId',
        'manufacturerId',
        'categoryId',
        'grandparentId',
        'packageQty',
        'searchable',
        'fromOrderHistory',
        'parentId',
        'modifierValueId',
      ]
      const filterByName = (object, nameList) => {
        Object.keys(object).forEach((key) => {
          if (!nameList.includes(key)) delete object[key]
        })
        return object
      }
      const actualFilters = filterByName(
        { ...this.catalogFiltersFromStore },
        filterNameList
      )
      queryFilters = filterByName({ ...queryFilters }, filterNameList)
      let isDirty = false
      for (const filterName in actualFilters) {
        if (!isEqual(actualFilters[filterName], queryFilters[filterName])) {
          actualFilters[filterName] = queryFilters[filterName]
          isDirty = true
        }
      }
      if (isDirty) {
        this.setFiltersOnly({
          ...this.catalogFiltersFromStore,
          ...actualFilters,
        })
      }

      await this.$nextTick(() => {
        this.setFiltersWatcher()
      })
    },
  },
}
